interface ReportsTabTriggerProps {
  label: string
  count?: number
}

export const ReportsTabTrigger = ({ label, count }: ReportsTabTriggerProps) => (
  <span className="inline-flex items-center gap-1.5">
    <span>{label}</span>
    {count !== undefined && (
      <span className="inline-flex items-center justify-center min-w-4 h-4 px-1 rounded-md text-[12px] font-semibold leading-none bg-neutralColor30 text-neutralColor">
        {count}
      </span>
    )}
  </span>
)
